import React from 'react';

export default class TabsControl extends React.Component {

    constructor() {
        super();
        this.state = {
            currentIndex: 0,
         }
    }


    check_title_index = index => index === this.state.currentIndex ? "tab_active" : ""

    check_item_index = index => index === this.state.currentIndex ? "tab_show" : "tab_hide"

    render() {
        return (
            <div >
                <div className="flex-static bill-btn-box">
                    {
                        React.Children.map(this.props.children, (item, index) => {
                            return (
                                <div onClick={ () => this.setState({ currentIndex: index }, ()=> {this.props.specClick(this.state.currentIndex + 1)}) } style={{ marginRight : index === 0 ? "15px" : "", cursor: "pointer" }} className={this.check_title_index(index)}>
                                    { item.props.name }
                                </div>
                            )
                        })
                    }
                </div>

                <div>
                    {
                        React.Children.map(this.props.children, (item, index) => {
                            return (
                                <div className={ this.check_item_index(index) } >
                                    {item}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/BillMessage/TabSwitch.jsx